import classNames from 'classnames';
import { FC } from 'react';

// Extend the interface to include a disabled prop
export interface ISwitchProps {
  label?: string;
  checked?: boolean;
  setChecked?: (a: boolean) => void;
  disabled?: boolean; // Added disabled prop
}

export const Switch: FC<ISwitchProps> = ({ label, checked, setChecked, disabled = false }) => {
  return (
    <div
      className={classNames('w-max flex gap-5 items-center', {
        'cursor-not-allowed opacity-50': disabled,
        'cursor-pointer': !disabled, // Conditional styling for disabled state
      })}
      onClick={() => {
        if (!disabled) {
          setChecked && setChecked(!checked);
        }
      }}
    >
      <div className="relative flex flex-col items-center justify-center min-h-[30px] overflow-hidden shrink-0">
        <div className="flex">
          <label className="flex relative items-center cursor-pointer">
            <input
              type="radio"
              className="sr-only peer"
              checked={checked}
              readOnly={true}
              disabled={disabled} // Apply disabled prop to the input
              onClick={(e) => {
                e.stopPropagation(); // Stop the event from bubbling
              }}
            />
            <span
              className={classNames(
                "w-[50px] h-[30px] bg-[#E0E0E8] rounded-[16px] peer  peer-focus:ring-green-500 peer-checked:after:translate-x-[20px] peer-checked:after:border-green-500 peer-checked:after:bg-green-500 after:content-[''] after:absolute after:top-[5px] after:left-[5px] after:bg-[#585858] after:border-[#585858] after:border after:rounded-full after:h-[20px] after:w-[20px] after:shadow-switch after:transition-all hover:bg-[#b3b4b9]",
                {
                  'bg-[#B0B0B8] after:bg-[#888888] after:border-[#888888] peer-checked:after:bg-[#B0B0B8] peer-checked:after:border-[#B0B0B8]':
                    disabled,
                  'bg-[#E0E0E8] after:bg-[#585858] after:border-[#585858] peer-checked:after:bg-green-500 peer-checked:after:border-green-500 hover:bg-[#b3b4b9]':
                    !disabled,
                },
              )}
            ></span>
          </label>
        </div>
      </div>
      <p className="text-base text-blackBase font-medium">{label}</p>
    </div>
  );
};
